import { array, bool, shape } from "prop-types"
import Registrations from "components/admin/Registrations"
import SectionFooter from "./SectionFooter"
import RegistrantQuestions from "./RegistrantQuestions"

const SimpleRegistration = ({
  event,
  registration,
  isActingStaff,
  isAdmin,
  isRegisterForSeparateEventsEnabled,
  signupTimes
}) => {
  return (
    <>
      <Registrations
        event={event}
        attendeeTypes={event.attendeeTypes}
        registration={registration}
        registrationContact={registration.responsiblePerson}
        simpleAttendees={registration.attendees}
        registerForSeparateTimesEnabled={isRegisterForSeparateEventsEnabled}
        isAdmin={isAdmin}
        signupTimes={signupTimes}
      />

      <SectionFooter
        event={event}
        registration={registration}
        isActingState={isActingStaff}
        hasEmailButton
        hasDeleteButton
        hasCancelButton
        hasFinalizeButton
      />

      {registration.questions.length > 0 && (
        <RegistrantQuestions registration={registration} questions={registration.questions} />
      )}
    </>
  )
}

SimpleRegistration.propTypes = {
  event: shape({
    attendeeTypes: array,
    isFree: bool
  }),
  registration: shape({
    responsiblePerson: shape({}),
    attendees: array
  }),
  isActingStaff: bool,
  isAdmin: bool,
  isRegisterForSeparateEventsEnabled: bool,
  signupTimes: array
}

export default SimpleRegistration
